// import React, { useState } from "react";
// import ParentNavBar from "./Navbar/ParenComponent";
// import GradientWrapper from "./GradientWrapper/GradientWrapper";
// import Footer from "./Footer/Footer";
// import MovieCard from "./MovieCard/MovieCard";
// import i1 from "../assets//gallery1.png";
// import i2 from "../assets//gallery2.png";
// import i3 from "../assets/i3.webp";
// import i4 from "../assets/i4.webp";
// import i5 from "../assets/i5.webp";
// import i6 from "../assets/i6.webp";
// import i7 from "../assets/i11.webp";
// import i8 from "../assets/i8.webp";
// import i9 from "../assets/i9.webp";
// import i10 from "../assets/i10.webp";
// import { Carousel } from "flowbite-react";

// import Flickity from "react-flickity-component";
// import Overlay from "./Overlay/Overlay";
// import { Box, IconButton } from "@mui/material";
// import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";
// import "./Gallery.css";

// const Gallery = () => {
//   return (
//     <>
//       <GradientWrapper isDisplayFlex={true}>
//         <ParentNavBar />
//         <GalleryContainer />
//       </GradientWrapper>
//       <Footer />
//     </>
//   );
// };

// const GalleryContainer = () => {
//   const [showOverlayCarousel, setShowOverlayCarousel] = useState(false);
//   const [initial, setInitial] = useState(0);
//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "row",
//         flexWrap: "wrap",
//         justifyContent: "start",
//         gap: 20,
//         paddingTop: 150,
//         paddingLeft: 20,
//         paddingRight: 20,
//       }}
//     >
//       {showOverlayCarousel && (
//         <Overlay
//           ImagesComponent={() => {
//             return (
//               <CarouselComponent
//                 images={[i1, i2, i3, i4, i5, i6, i7, i8]}
//                 index={initial}
//               />
//             );
//           }}
//           onClose={() => {
//             setTimeout(() => {
//               setShowOverlayCarousel(false);
//             }, 100);
//           }}
//         />
//       )}
//       <MovieCard
//         imageUrl={i1}
//         onPressCard={() => {
//           setInitial(0);
//           setShowOverlayCarousel(true);
//         }}
//       />
//       <MovieCard
//         imageUrl={i2}
//         onPressCard={() => {
//           setInitial(1);
//           setShowOverlayCarousel(true);
//         }}
//       />
//       <MovieCard
//         imageUrl={i3}
//         onPressCard={() => {
//           setInitial(2);
//           setShowOverlayCarousel(true);
//         }}
//       />
//       <MovieCard
//         imageUrl={i4}
//         onPressCard={() => {
//           setInitial(3);
//           setShowOverlayCarousel(true);
//         }}
//       />
//       <MovieCard
//         imageUrl={i5}
//         onPressCard={() => {
//           setInitial(4);
//           setShowOverlayCarousel(true);
//         }}
//       />
//       <MovieCard
//         imageUrl={i6}
//         onPressCard={() => {
//           setInitial(5);
//           setShowOverlayCarousel(true);
//         }}
//       />
//       <MovieCard
//         imageUrl={i7}
//         onPressCard={() => {
//           setInitial(6);
//           setShowOverlayCarousel(true);
//         }}
//       />
//       <MovieCard
//         imageUrl={i8}
//         onPressCard={() => {
//           setInitial(7);
//           setShowOverlayCarousel(true);
//         }}
//       />
//       <MovieCard
//         imageUrl={i9}
//         onPressCard={() => {
//           setInitial(8);
//           setShowOverlayCarousel(true);
//         }}
//       />
//       <MovieCard
//         imageUrl={i10}
//         onPressCard={() => {
//           setInitial(9);
//           setShowOverlayCarousel(true);
//         }}
//       />
//     </div>
//   );
// };

// export default Gallery;

// function CarouselComponent({ index, images }) {
//   const NextArrow = ({ onClick }) => (
//     <IconButton
//       onClick={onClick}
//       style={{
//         position: "absolute",
//         right: 0,
//         top: "50%",
//         transform: "translateY(-50%)",
//         zIndex: 100000000,
//       }}
//     >
//       <ArrowForwardIos />
//     </IconButton>
//   );

//   const PrevArrow = ({ onClick }) => (
//     <IconButton
//       onClick={onClick}
//       style={{
//         position: "absolute",
//         left: 0,
//         top: "50%",
//         transform: "translateY(-50%)",
//         zIndex: 100000000,
//       }}
//     >
//       <ArrowBackIos />
//     </IconButton>
//   );
//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     initialSlide: index,
//     appendDots: (dots) => (
//       <Box
//         component="ul"
//         sx={{
//           margin: 0,
//           padding: 0,
//           display: "flex",
//           justifyContent: "center",
//           listStyle: "none",
//         }}
//       >
//         {dots}
//       </Box>
//     ),
//     customPaging: (i) => (
//       <Box
//         sx={{
//           width: "10px",
//           height: "10px",
//           borderRadius: "50%",
//           backgroundColor: "grey",
//           display: "inline-block",
//           margin: "0 5px",
//           cursor: "pointer",
//         }}
//       />
//     ),
//   };
//   return (
//     <Box sx={{ position: "relative", width: "100%", margin: "auto" }}>
//       <Slider {...settings}>
//         {images.map((image, index) => (
//           <Box
//             key={index}
//             component="div"
//             style={{
//               alignItems: "center",
//               justifyContent: "center",
//               display: "flex",
//             }}
//             sx={{
//               textAlign: "center",
//             }}
//           >
//             <Box
//               component="img"
//               src={image}
//               alt={`carousel image ${index + 1}`}
//               style={{
//                 alignItems: "center",
//                 justifyContent: "center",
//                 display: "flex",
//                 objectFit: "contain",
//                 width: "100%",
//                 height: "70vh",
//               }}
//               sx={{ borderRadius: "10px" }}
//             />
//           </Box>
//         ))}
//       </Slider>
//     </Box>
//   );
// }

import React from "react";
// import ParentNavBar from "./Navbar/ParentComponent.js";
import Footer from "./Footer/Footer.js";
import "./home.css";
import GradientWrapper from "./GradientWrapper/GradientWrapper.js";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Grid,
  Divider,
  ListItemText,
  ListItem,
  List,
} from "@mui/material";
import ParentNavBar from "./Navbar/ParenComponent.js";

const Gallery = () => {
  return (
    <>
      <GradientWrapper>
        <ParentNavBar />
        <Box sx={{ height: 100 }}></Box>

        {/* Media Section */}
        <Box sx={{ px: 2, backgroundColor: "#fff" }}>
          <Grid container flexDirection="column" alignItems="center">
            <Typography
              variant="h4"
              sx={{
                mb: 2,
                maxWidth: 800,
                marginLeft: "auto",
                marginRight: "auto",
                width: "100%",
              }}
            >
              Media
            </Typography>

            <Grid
              sx={{
                maxWidth: 800,
                minWidth: 280,
                mx: 2,
              }}
            >
              <MovieCard />
            </Grid>
          </Grid>
        </Box>

        {/* Quotes Section */}
        <Divider sx={{ my: 3 }} />
        <Typography
          variant="h4"
          sx={{
            mb: 2,
            maxWidth: 800,
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "center",
          }}
        >
          Quotes
        </Typography>
        <TestimonialsCard />

        {/* Events Section */}
        <Divider sx={{ my: 3 }} />
        <Typography
          variant="h4"
          sx={{
            mb: 2,
            maxWidth: 800,
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "center",
          }}
        >
          Events
        </Typography>
        <EventsAndFestivalsCard />

        {/* Credits Section */}
        <Divider sx={{ my: 3 }} />
        <Typography
          variant="h4"
          sx={{
            mb: 2,
            maxWidth: 800,
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "center",
          }}
        >
          Credits
        </Typography>
        <CreditsCard2 />

        {/* Additional Education Section */}
        <Divider sx={{ my: 3 }} />
        <AdditionalEducation />
      </GradientWrapper>

      <Footer />
    </>
  );
};

export default Gallery;

const MovieCard = () => {
  return (
    <>
      {/* Card for L'Inverno from Budapest Reporter */}
      <Card sx={{ boxShadow: 3, mb: 2 }}>
        <CardContent sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h5" gutterBottom>
            L’Inverno
          </Typography>
          <Typography variant="body2" paragraph>
            "L’Inverno brings the tale of WWII Era forbidden love to the
            cinemas. The emotional storyline explores a deep and touching
            narrative."
          </Typography>
          <Typography variant="body2" color="text.secondary" align="right">
            - https://www.budapestreporter.com
          </Typography>
        </CardContent>
        <Box sx={{ textAlign: "center", pb: 2 }}>
          <Button
            size="small"
            color="primary"
            href="https://www.budapestreporter.com/linverno-to-bring-wwii-era-forbidden-love-to-the-cinemas/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </Button>
        </Box>
      </Card>

      {/* Additional card for L’Inverno */}
      <Card sx={{ boxShadow: 3 }}>
        <CardContent sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h5" gutterBottom>
            L’Inverno
          </Typography>
          <Typography variant="body2" paragraph>
            "L’Inverno is the first pic to emerge from APX’s new Music World
            Films & TV venture — a new division headed by Mathew Knowles."
          </Typography>
          <Typography variant="body2" color="text.secondary" align="right">
            - https://variety.com/
          </Typography>
        </CardContent>
        <Box sx={{ textAlign: "center", pb: 2 }}>
          <Button
            size="small"
            color="primary"
            href="https://variety.com/2022/film/global/roland-joffe-olivier-martinez-inverno-apx-1235220982/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read More
          </Button>
        </Box>
      </Card>
    </>
  );
};

const TestimonialsCard = () => {
  return (
    <Card sx={{ maxWidth: 800, mx: "auto", boxShadow: 3, my: 3 }}>
      <CardContent>
        <Typography variant="h4" gutterBottom>
          L'Inverno Testimonials
        </Typography>

        {/* Testimonial from Roland Joffé */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            Roland Joffé, Director of "The Killing Fields" and "The Mission"
          </Typography>
          <Typography variant="body1">
            "The making of 'L'Inverno' has been an incredibly moving process.
            The film is a captivating and intense character-driven tale."
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Testimonial from Ron Elisha */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            Award-winning Writer Ron Elisha
          </Typography>
          <Typography variant="body1">
            "'L'Inverno' is a finely wrought and profoundly moving story whose
            characters bring home to us the dilemmas of the Holocaust."
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Testimonial from Kim and Kathryn Klug */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            Kim and Kathryn Klug, Composers
          </Typography>
          <Typography variant="body1">
            "Kathryn and I have read your masterful 'L'Inverno' and both feel
            that it's the best script we've ever read."
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

const EventsAndFestivalsCard = () => {
  return (
    <Card sx={{ maxWidth: 800, mx: "auto", boxShadow: 3, my: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Events and Festivals
        </Typography>

        <Typography variant="body1" paragraph>
          Festival de Cannes, Venice Film Festival, Viennale Vienna, Sydney Film
          Festival, Jewish Film Festival, and more.
        </Typography>

        <Typography variant="body1" sx={{ mt: 2 }}>
          Sharron has traveled extensively, working across Europe and other
          continents for 20+ years.
        </Typography>
      </CardContent>
    </Card>
  );
};

const CreditsCard2 = () => {
  return (
    <Card sx={{ maxWidth: 800, mx: "auto", boxShadow: 3, my: 3 }}>
      <CardContent>
        <Typography variant="h4" gutterBottom>
          Sharron Aubrey
        </Typography>

        {/* Theatre Credits */}
        <Typography variant="h5" gutterBottom>
          Theatre Credits
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <ListItem>
              <ListItemText
                primary="One of Us"
                secondary="World Premiere | Role: Production Development | Playwright: Ron Elisha"
              />
            </ListItem>
            <Divider />
          </Grid>
          {/* Additional theatre credits */}
        </Grid>

        {/* Film Credits */}
        <Typography variant="h5" sx={{ mt: 3 }} gutterBottom>
          Film Credits
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <ListItem>
              <ListItemText
                primary="Sugar"
                secondary="Feature/Development | Roles: Producer, Screenwriter, Actor"
              />
            </ListItem>
            <Divider />
          </Grid>
          {/* Additional film credits */}
        </Grid>
      </CardContent>
    </Card>
  );
};

const AdditionalEducation = () => {
  return (
    <Card sx={{ maxWidth: 800, mx: "auto", boxShadow: 3, my: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Education & Expertise
        </Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>
          Sharron has explored various fields, including Humanities and
          Naturopathy. She holds a Master's degree in Education and Linguistics.
        </Typography>
      </CardContent>
    </Card>
  );
};
